<style lang="less"></style>

<template>
    <MenuList :menuList="menuList" @handleClicks="handleClicks(...arguments)" />
</template>

<script lang="ts">
    declare var EDDocument: any;
    declare var eSnapFlags: any;
    import { Component, Prop, Vue } from "vue-property-decorator";
    import MenuList from "@/app/components/MenuList.vue";

    @Component({
        components: {
            MenuList,
        },
    })
    export default class guidesMenus extends Vue {
        get menuList() {
            return {
                list: [
                    { label: this.$t("showGuides"), checked: this.isShowGuideline },
                    { label: this.$t("snapGuides"), checked: this.isShowSnapGuideline },
                ],
            };
        }
        handleClicks(...args) {
            let index = args[0];
            // index 为0或1，多于两种情况需优化条件语句
            if (index) {
                this.snapGuides();
            } else {
                this.toggleGuide();
            }
        }
        closeDrop() {
            this.$emit("closeDrop");
        }
        toggleGuide() {
            let checked = !window["_view"]._doc._config._showGuideline;
            window["_view"].showGuideLinesBox(checked);
            this.$track("menu", "view", "toggleGuide" + checked);
            this.closeDrop();
        }
        snapGuides() {
            let checked = !!(EDDocument._gcfg._snapFlags & eSnapFlags.GuideLine);
            window["_view"].snapToGuideLine(!checked);
            this.$track("menu", "view", "snapGuides" + checked);
            this.closeDrop();
        }

        get isShowGuideline() {
            return this.$store.state.page.showGuideline;
        }
        get isShowSnapGuideline() {
            return this.$store.state.page.showSnapGuideline;
        }

        mounted() {}

        created() {}
    }
</script>
<i18n>
{
  "zh": {
    "showGuides": "显示参考线",
    "snapGuides": "吸附参考线"
  },
  "en": {
    "showGuides": "Show Guides",
    "snapGuides": "Snap to Guides"
  },
  "fr": {
    "showGuides": "Afficher les Guides",
    "snapGuides": "Accrocher aux Guides"
  },
  "de": {
    "showGuides": "Führungslinien anzeigen",
    "snapGuides": "An Führungslinien ausrichten"
  },
  "jp": {
    "showGuides": "ガイドライン",
    "snapGuides": "ガイドラインにスナップ"
  },
  "es": {
    "showGuides": "Guías de espectáculos",
    "snapGuides": "Ajustar a guías"
  },
  "pt": {
    "showGuides": "Mostrar Guias",
    "snapGuides": "Encaixar para Guias"
  },
  "it": {
    "showGuides": "Mostra Guide",
    "snapGuides": "Aggancia a Guide"
  },
  "tw": {
    "showGuides": "顯示參考線",
    "snapGuides": "吸附參考線"
  }
}
</i18n>
